<template>
  <transition name="fade">
    <div class="img-link-float" v-show="show && showBanner">
      <img-v3 :src="formItem.img_url" />
      <p v-if="formItem.title" class="img-title" @click="goLink">
        {{ formItem.title }}
        <img-v3 :src="require('../../images/icon_arrow@3x.png')" alt="" />
      </p>
      <p v-if="formItem.desc" class="img-desc">{{ formItem.desc }}</p>
      <img-v3 :src="formItem.close_icon" class="img-close" @click="close" />
    </div>
  </transition>
</template>
<script>
import { mapState } from "vuex";
import { ends } from "../../tools/constant";
import { getEnd } from "../../tools/utils";

export default {
  props: ["formItem", "idx"],
  data() {
    return {
      show: true,
      showBanner: true,
    };
  },
  created() {
    window.addEventListener("scroll", this.scrollBottom);
  },
  mounted() {
    let clientHeight = document.documentElement.clientHeight;
    let scrollHeight = document.documentElement.scrollHeight;
    let warpDiv = document.querySelector(".has-img-float");
    let btnDiv = document.querySelector(".has-img-float .btn-wraper");
    // 页面不滚动的情况下防止banner遮挡跳转按钮
    if (clientHeight === scrollHeight) {
      warpDiv.style.paddingBottom = "5rem";
      btnDiv.style.paddingBottom = "2rem";
    }
  },
  methods: {
    scrollBottom() {
      let scrollTop = document.documentElement.scrollTop;
      let clientHeight = document.documentElement.clientHeight;
      let scrollHeight = document.documentElement.scrollHeight;
      // if (clientHeight === scrollHeight) return
      if (scrollTop + clientHeight >= scrollHeight - 30) {
        this.showBanner = false;
      } else {
        this.showBanner = true;
      }
    },
    reset() {
      Fusion.resetBack &&
        Fusion.resetBack({
          reset: 2,
        });
      //20200228 vamos设置返回拦截
      Fusion.interceptGoback &&
        Fusion.interceptGoback({ needs_intercept: false }, () => {});
    },
    goLink() {
      if (this.formItem.link) {
        if (ends.isIOS) {
          location.href = this.linkGenerator(this.formItem.link.ios);
        } else {
          location.href = this.linkGenerator(this.formItem.link.android);
        }
      }
    },
    close() {
      this.show = false;
    },
    linkGenerator(url) {
      const onelinkGenerator = new window.AF.OneLinkUrlGenerator({
        oneLinkURL: url,
        pidKeysList: ["source"],
        // pidOverrideList: {
        //   'joveo': 'joveo_int',
        //   'jampp': 'jampp_int',
        //   'google': 'googleadwords_int',
        //   'facebook':'Facebook Ads'
        // },
        campaignKeysList: ["utm_campaign"],
      });
      onelinkGenerator.setChannel("utm_source"); // Input value
      onelinkGenerator.setCustomParameter("campaign_id", "af_c_id"); // Input Output value
      onelinkGenerator.setAdset("ad_group_id");
      onelinkGenerator.setAd("creative_id");
      onelinkGenerator.setCustomParameter("keyword", "af_keywords");
      onelinkGenerator.setCustomParameter("adposition", "af_siteid");
      onelinkGenerator.setAfSub1("gclid");
      onelinkGenerator.setAfSub2("fbclid");
      return onelinkGenerator.generateUrl();
    },
  },
  computed: {
    ...mapState(["_ticket", "_product"]),
  },
  destroyed() {
    console.log(this);
  },
};
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transform: translateY(0);
}
.fade-enter,
.fade-leave-to {
  transform: translateY(100%);
}
.img-link-float {
  transition: all 0.3s ease;
  position: fixed;
  bottom: 0;
  left: 0;
  > img {
    display: block; //解决下边距3px空白
    width: 100%;
  }
  .img-title {
    position: absolute;
    left: 1.52rem;
    top: 0.22rem;
    right: 0.32rem;
    font-size: 0.32rem;
    color: #333333;
    font-weight: 700;
    > img {
      width: .24rem;
      height: .24rem;

    }
  }
  .img-desc {
    position: absolute;
    top: 0.68rem;
    left: 1.52rem;
    font-size: 0.24rem;
    color: #666666;
    font-weight: 400;
  }
  .img-close {
    position: absolute;
    right: 0;
    top: 0;
    width: 0.4rem;
  }
}
</style>

